import {Controller} from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";

export default class extends Controller {
    static targets = [];

    connect() {
        const toastElList = document.querySelectorAll('.toast')
        const toastList = [...toastElList].map(toastEl => new bootstrap.Toast(toastEl))
    }
}